import { cn } from "@/lib/utils"

/**
 * Logotype texte, en attendant le logo définitif.
 * Pour passer à une image : remplacer le contenu par <Image …/>, les
 * emplacements (barre haute, footer) n'ont alors pas à changer.
 */
function Wordmark({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      className={cn(
        "font-heading text-[1.375rem] leading-none font-bold tracking-[0.2em] whitespace-nowrap uppercase",
        className
      )}
      {...props}
    >
      Cairn
    </span>
  )
}

export { Wordmark }
